(function () {
  'use strict';

  var drawer = document.getElementById('sidebar-cart');
  if (!drawer) return;

  var refreshTimer;
  var latestRequest = 0;

  function isRetailCart() {
    // Wholesale All In One can set prices through a separate checkout path.
    // Liquid guards its configured customer tag even if the app script is late.
    if (drawer.getAttribute('data-wholesale-customer') === 'true') return false;
    try {
      return !window.WSAIO ||
        typeof window.WSAIO.isWholesaleCustomer !== 'function' ||
        window.WSAIO.isWholesaleCustomer() === false;
    } catch (error) {
      return false;
    }
  }

  function showShopifyTotals() {
    if (!isRetailCart()) {
      drawer.classList.remove('Cart--native-totals');
      return;
    }

    var nativeSummary = drawer.querySelector('[data-native-cart-summary]');
    var appSubtotal = drawer.querySelector('.docapp-cart-with-shipping-summary .docapp-cart-subtotal .money');
    var checkoutAmount = drawer.querySelector('.Cart__Checkout .drwr_subb');
    if (!nativeSummary || !appSubtotal || !checkoutAmount) {
      drawer.classList.remove('Cart--native-totals');
      return;
    }

    var subtotal = nativeSummary.querySelector('[data-native-cart-subtotal]');
    var total = nativeSummary.querySelector('[data-native-cart-total]');
    if (!subtotal || !total) return;

    // Shopify renders these amounts in the visitor's presentment currency.
    // Updating text only preserves the app's coupon and shipping controls.
    var subtotalText = subtotal.textContent.trim();
    var totalText = total.textContent.trim();
    if (appSubtotal.textContent.trim() !== subtotalText) appSubtotal.textContent = subtotalText;
    if (checkoutAmount.textContent.trim() !== totalText) checkoutAmount.textContent = totalText;
    drawer.classList.add('Cart--native-totals');
  }

  function refreshShopifyTotals() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      if (!isRetailCart() || !window.routes || !window.routes.cartUrl) return;
      var request = ++latestRequest;
      var url = window.routes.cartUrl + '?section_id=mini-cart&timestamp=' + Date.now();

      // Section rendering reruns Liquid after a coupon changes the Shopify cart.
      // It avoids estimating discount percentages or formatting money in JS.
      fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Cart section unavailable');
        return response.text();
      }).then(function (html) {
        if (request !== latestRequest) return;
        var section = new DOMParser().parseFromString(html, 'text/html');
        var updated = section.querySelector('#sidebar-cart [data-native-cart-summary]');
        var current = drawer.querySelector('[data-native-cart-summary]');
        if (!updated || !current) return;
        current.replaceWith(updated);
        showShopifyTotals();
      }).catch(function () {
        // Keep the last Shopify-rendered amount; never invent a price on error.
      });
    }, 300);
  }

  document.body.addEventListener('docapp-applied-discount-code-changed', refreshShopifyTotals);
  document.body.addEventListener('docapp-discount-applied', refreshShopifyTotals);

  // The theme replaces the drawer form after cart changes. The discount app
  // can mount its panel or rewrite the checkout amount later. Watch those
  // specific nodes so a late app update cannot restore the stale price.
  new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (mutation) {
      var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
      if (target && target.closest('.docapp-cart-with-shipping-summary, .Cart__Checkout .drwr_subb')) return true;
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        return node.nodeType === 1 &&
          (node.matches('[data-native-cart-summary], .docapp-cart-with-shipping-summary, .Cart__Checkout .drwr_subb') ||
            node.querySelector('[data-native-cart-summary], .docapp-cart-with-shipping-summary, .Cart__Checkout .drwr_subb'));
      });
    });
    if (relevant) showShopifyTotals();
  }).observe(drawer, { childList: true, characterData: true, subtree: true });

  showShopifyTotals();
}());
